import {rubicon_config} from './rubicon_config';
import _ from 'lodash';

export function generateBidders(adUnit, sizes) {
  const commonConfig = _.result(rubicon_config, 'all', {});
  const config = _.result(rubicon_config, `${adUnit.name}`, null);
  if (_.isEmpty(config)) return {};
  if (_.isNumber(adUnit.floor) && adUnit.floor !== 0 && !_.isNaN(adUnit.floor)) config['floor'] = adUnit.floor;
  return {
    rubicon: {
      ...config,
      ...commonConfig
    },
  }
}
